export default "__VITE_ASSET__9AXzTirL__"